export default {
  eventQuizset: null,
  eventId: '',
  quizset: {},
  quizsets: []
}
